module.exports = __webpack_public_path__ + "img/logo_lg_light.62d2b300.svg";